// assets
import { Alarm, Gallery, HomeTrendUp, LockCircle, Message, Money, NotificationStatus, People, Setting, Story } from 'iconsax-react';

// third-party
import { FormattedMessage } from 'react-intl';

// import { Home3, HomeTrendUp } from 'iconsax-react';

// icons
const icons = {
  widgets: Story,
  statistics: Story,
  people: People,
  dashboard: HomeTrendUp,
  donation: Money,
  data: Gallery,
  customer: NotificationStatus,
  settings: Setting,
  message: Message,
  types: Alarm,
  roles: LockCircle
};

// ==============================|| MENU ITEMS - WIDGETS ||============================== //

const dashboard = {
  id: 'group-admin',
  // title: <FormattedMessage id="widgets" />,
  icon: icons.widgets,
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: <FormattedMessage id="Dashboard" />,
      type: 'item',
      url: '/dashboard/statistics',
      icon: icons.dashboard,
      breadcrumbs: false
    },
    {
      id: 'transactions',
      title: <FormattedMessage id="Transactions" />,
      type: 'item',
      url: '/dashboard/donation',
      icon: icons.donation,
      breadcrumbs: false
    },
    {
      id: 'stackholders',
      title: <FormattedMessage id="Stackholders" />,
      type: 'item',
      url: '/dashboard/stackholders',
      icon: icons.donation,
      breadcrumbs: false
    },
    // {
    //   id: 'service',
    //   title: <FormattedMessage id="Service Types" />,
    //   type: 'item',
    //   url: '/dashboard/service-types',
    //   icon: icons.types,
    //   breadcrumbs: false
    // },
    {
      id: 'announcement',
      title: <FormattedMessage id="Announcement" />,
      type: 'collapse',
      breadcrumbs: false,
      icon: icons.customer,

      children: [
        {
          id: 'Donation',
          title: <FormattedMessage id="List" />,
          type: 'item',
          url: '/dashboard/announcement',
          breadcrumbs: false
        },
        {
          id: 'Categories',
          title: <FormattedMessage id="Categories" />,
          type: 'item',
          url: 'dashboard/announcement/categories',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'gallery',
      title: <FormattedMessage id="Gallery" />,
      type: 'item',
      url: '/dashboard/gallery',
      icon: icons.data,
      breadcrumbs: false
    }

    // {
    //   id: 'message',
    //   title: <FormattedMessage id="Message" />,
    //   type: 'item',
    //   url: '/dashboard/message',
    //   icon: icons.message,
    //   breadcrumbs: false
    // },

    // {
    //   id: 'service-types',
    //   title: <FormattedMessage id="Service Types" />,
    //   type: 'item',
    //   url: '/dashboard/serviceTypes',
    //   icon: icons.types,
    //   breadcrumbs: false
    // }
    // {
    //   id: 'users',
    //   title: <FormattedMessage id="Users" />,
    //   type: 'item',
    //   url: '/dashboard/users',
    //   icon: icons.roles,
    //   breadcrumbs: false
    // }
    // {
    //   id: 'roles',
    //   title: <FormattedMessage id="Roles & Permissions" />,
    //   type: 'item',
    //   url: '/dashboard/roles-permissions',
    //   icon: icons.roles
    // }
    // {
    //   id: 'admin-settings',
    //   title: <FormattedMessage id="Admin Settings" />,
    //   type: 'item',
    //   url: '/dashboard/settings',
    //   icon: icons.settings,
    //   breadcrumbs: false
    // }
  ]
};

export default dashboard;
